import { DEFAULT_NOTIFICATIONS_LIMIT } from '../../../common/constants';

export function fetchUnreadNotificationsSuccess(state, notifications) {
  return {
    ...state,
    account: {
      ...state.account,
      notifications: {
        items: notifications.items,
        count: notifications.count,
      },
    },
  };
}

export function changeActiveNotification(state, notification) {
  return {
    ...state,
    account: {
      ...state.account,
      activeNotification: notification,
    },
  };
}

export function newNotificationReceived(state, newNotification) {
  let notificationsArray = state.account.notifications.items;
  if (notificationsArray.length >= DEFAULT_NOTIFICATIONS_LIMIT) {
    notificationsArray = [
      newNotification,
      ...notificationsArray.slice(1, DEFAULT_NOTIFICATIONS_LIMIT),
    ];
  } else {
    notificationsArray = [
      newNotification,
      ...notificationsArray,
    ];
  }
  return {
    ...state,
    account: {
      ...state.account,
      notifications: {
        items: notificationsArray,
        count: state.account.notifications.count + 1,
      },
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/notifications.js
 **/